import { render, staticRenderFns } from "./ProblemListPopup.vue?vue&type=template&id=7fa438aa&scoped=true&"
import script from "./ProblemListPopup.vue?vue&type=script&lang=js&"
export * from "./ProblemListPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProblemListPopup.vue?vue&type=style&index=0&id=7fa438aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa438aa",
  null
  
)

export default component.exports